import React, { useState } from 'react';

import { Button } from '@components/Button';

const CExpandCollapse = React.memo(
	({ className, heading, children, isFar, isNear }) => {
		const [expanded, toggleExpand] = useState(false);

		return (
			<div className={className}>
				<div
					className={`font-bold mt-2 flex items-center ${
						isFar ? 'justify-between' : ''
					}`}
					style={{
						cursor: 'pointer',
						userSelect: 'none',
					}}
					onClick={() => {
						toggleExpand(!expanded);
					}}
				>
					{heading}
					<Button
						variant="minimal"
						size="vtiny"
						className="ml-4 p-2 u-hoverOpacity"
					>
						{expanded
							? String.fromCharCode(9650)
							: String.fromCharCode(9660)}
					</Button>
				</div>
				<div className={!expanded ? 'hidden' : ''}>{children}</div>
			</div>
		);
	}
);

export default CExpandCollapse;
